import Posthog, { init } from './init'
export { PostHogProvider } from 'posthog-js/react'
export * from './use-posthog'
export * from './types'

export { init }

export default Posthog
